import React from 'react';
import { CaseStudyCard } from './CaseStudyCard';
import { SparklesIcon } from 'lucide-react';
interface CaseStudiesSectionProps {
  onNavigate?: (sectionId: string) => void;
}
const caseStudies = [{
  title: 'Overcoming Chronic Bacterial Prostatitis',
  description: 'Complete recovery from chronic bacterial prostatitis after years of unsuccessful treatments',
  category: 'Urological Health',
  videoUrl: 'https://www.youtube.com/watch?v=lgcmDHXRMjw'
}, {
  title: 'Defying Age: From Burnout to 15-Year Biological Age Reversal',
  description: 'Remarkable transformation from complete burnout to reversing biological age by 15 years',
  category: 'Anti-Aging & Longevity',
  videoUrl: 'https://youtu.be/YwEywZxMSgo'
}, {
  title: 'From Cognitive Decline to Mental Superhuman',
  description: 'Complete cognitive restoration and enhancement beyond baseline function',
  category: 'Cognitive Health',
  videoUrl: 'https://www.youtube.com/watch?v=bdFY2s3nbtM'
}, {
  title: "Reversing Alzheimer's Disease: The Breakthrough Approach",
  description: "Groundbreaking protocol reversing Alzheimer's disease progression in our clients",
  category: 'Neurological Health',
  videoUrl: 'https://www.youtube.com/watch?v=TEDmmZfPIa0'
}, {
  title: "Doctor Would've Killed Him if He Didn't Call Us",
  description: 'Life-saving intervention preventing fatal medical mismanagement',
  category: 'Critical Care',
  videoUrl: 'https://youtu.be/LEMYXVTYI-k'
}, {
  title: 'Beating "Incurable" Autoimmune Disease',
  description: "Reversing Rheumatoid Arthritis & Hashimoto's - conditions deemed impossible to cure",
  category: 'Autoimmune',
  videoUrl: 'https://www.youtube.com/watch?v=VLAbfsKtAvo'
}, {
  title: 'Reversing Heart Failure',
  description: 'Complete cardiac recovery from severe heart failure using advanced peptide protocols',
  category: 'Cardiovascular Health',
  videoUrl: 'https://www.youtube.com/watch?v=bmLQYGeC960'
}, {
  title: 'Complete Upgrade in Business & Life',
  description: 'Total performance enhancement with peptide therapy - transforming both professional and personal life',
  category: 'Performance Enhancement',
  videoUrl: 'https://www.youtube.com/watch?v=VxilMGM7uE8'
}, {
  title: 'High Radial Nerve Palsy Reversed',
  description: 'From wrist drop to full recovery - complete nerve regeneration and function restoration',
  category: 'Neurological Recovery',
  videoUrl: 'https://www.youtube.com/watch?v=DG-Tf01uqfk'
}, {
  title: 'How He Escaped Dialysis & Reversed Kidney Disease',
  description: 'Avoiding dialysis through revolutionary kidney regeneration protocol',
  category: 'Renal Health',
  videoUrl: 'https://www.youtube.com/watch?v=yrF73YFikJI'
}, {
  title: 'From Chronic Pain to Pain Free',
  description: 'Defeating osteoarthritis - complete pain elimination and joint function restoration',
  category: 'Pain Management',
  videoUrl: 'https://www.youtube.com/watch?v=226rmSgq68A'
}, {
  title: "Peptides Reversed My Autoimmune Disease – No More Sjogren's Syndrome",
  description: "Complete reversal of Sjogren's Syndrome using peptide therapy - overcoming chronic autoimmune condition",
  category: 'Autoimmune',
  videoUrl: 'https://youtu.be/wH98lWQw7NU'
}];
export function CaseStudiesSection({
  onNavigate
}: CaseStudiesSectionProps) {
  return <section id="success-stories" className="relative py-24 overflow-hidden" data-id="element-17">
      <div className="absolute inset-0 bg-gradient-to-b from-cyan-950/80 via-fuchsia-950/80 to-slate-900/90" data-id="element-18"></div>
      <div className="absolute top-0 left-0 right-0 h-32 bg-gradient-to-b from-cyan-950/50 to-transparent pointer-events-none" data-id="element-19"></div>
      <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/5 via-transparent to-fuchsia-500/5" data-id="element-20"></div>
      <div className="absolute top-1/3 right-0 w-96 h-96 bg-gradient-to-br from-cyan-500/10 to-transparent rounded-full blur-3xl" data-id="element-21"></div>
      <div className="absolute bottom-1/3 left-0 w-96 h-96 bg-gradient-to-tr from-fuchsia-500/10 to-transparent rounded-full blur-3xl" data-id="element-22"></div>
      <div className="max-w-7xl mx-auto px-6 relative" data-id="element-23">
        <div className="text-center mb-16" data-id="element-24">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-8 leading-tight" data-id="element-25">
            Scientific precision which allows us to create{' '}
            <span className="bg-gradient-to-r from-cyan-400 via-fuchsia-400 to-cyan-400 bg-clip-text text-transparent" data-id="element-26">
              incredible real-world transformations
            </span>{' '}
            that save lives.
          </h2>
          <p className="text-2xl font-bold text-white mb-4" data-id="element-27">
            Even when conventional medicine says it's "impossible."
          </p>
          <p className="text-3xl md:text-4xl font-bold bg-gradient-to-r from-cyan-400 via-fuchsia-400 to-cyan-400 bg-clip-text text-transparent" data-id="element-28">
            Here Are Some of Our Success Stories
          </p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-29">
          {caseStudies.map((study, index) => <CaseStudyCard key={index} {...study} data-id="element-30" />)}
        </div>
      </div>
    </section>;
}